import { fromJS } from "immutable"
import {
  GET_DIMENSIONS_DATA_WATCHER,
  GET_DIMENSIONS_DATA_SUCCESS,
  GET_DIMENSIONS_DATA_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoadingDimensionsData: true,
  dimensionsData: {}
})

function climateMeasurementReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DIMENSIONS_DATA_WATCHER:
      return state.set("isLoadingDimensionsData", true).set("dimensionsData", {})
    case GET_DIMENSIONS_DATA_SUCCESS:
      return state.set("isLoadingDimensionsData", false).set("dimensionsData", action.payload)
    case GET_DIMENSIONS_DATA_FAILED:
      return state.set("isLoadingDimensionsData", false).set("dimensionsData", {})
    default:
      return state
  }
}

export default climateMeasurementReducer
